import React, {useContext, useEffect, useRef, useState} from "react";

import {FormattedMessage, useIntl} from "react-intl";
import LoadingSpinner from "../../atoms/loadingSpinner/LoadingSpinner.jsx";
import Alert from "../../components/alert/AlertController.jsx";
import Footer from "../../components/footer/Footer.jsx";
import {Context as LoginContext} from "../../components/login/LoginController";
import NoAccess from "../../components/no_access/NoAccessAlertController.jsx";
import Settings from "../../components/settings/SettingsController.jsx";
import Welcome from "../../components/welcome/WelcomeController.jsx";
import {GlobalContext} from "../../globals/globalContext.jsx";
import useScreenWidth from "../../hooks/useScreenWidth.js";
import {put} from "../../util/fetch";
import CartHeader from "../cart-header/CartHeader.jsx";
import CartItemList from "../cart-item-list/CartItemList.jsx";
import CartOrderBar from "../cart-order-bar/CartOrderBar.jsx";
import CartSummary from "../cart-summary/CartSummary.jsx";
import CatalogItemList from "../catalog-item-list/CatalogItemList.jsx";
import {CartTop} from "./CartTop/CartTop.jsx";
import "./styles.styl";
import ShoppingCart from "jsx:../../assets/svgs/shopping_cart.svg";
import DownArrow from "jsx:../../assets/svgs/down-arrow.svg";

const styles = {
  colorPrimary: "",
  colorSecondary: "",
  logoSmallUrl: "",
};

export default function CartPage(props) {
  const {
    activeSearch,
    setActiveSearch,
    delivery,
    setDelivery,
    showRegistrationForm,
    setShowRegistrationForm,
    hasBeenClicked,
    browser_is_IE,
    showSettings,
    onChangeItems,
    onRemoveItems,
    onPropagateOrderedAmount,
    toggleForceEditable,
    onSwitchToEarlierDateIfExists,
    onSubmit,
    onTopClick,
    onRegisterSuccess,
    onSettingsClose,
    onSettingsChange,
    gmbhName,
    logoBigUrl,
    logoFavIcon,
    logoSmallUrl,
    phoneNumber,
    companyEmail,
    companyAddress,
    colorPrimary,
    colorSecondary,
    homePage,
    webhost,
    bioCertification,
    taxDetails,
    privacyPage,
    conditionsPage,
    companyName,
    deliveryName,
    addInvoicePaymentMethod,
    addSepaPaymentMethod,
    creditorIdentifier,
    sepaCsvEmail,
    paymentProvider,
    productType,
    filteredProductType,
    userLikedProducts,
    hasRules,
    ruleCount,
    setRuleCount,
    preferencesAndRulesLoaded,
    isLoadingPreferencesAndRules,
    fetchPreferencesAndRules,
    fetchCatalog,
    fetchDelivery,
    setProductType,
    setFilteredProductType,
    setUserLikedProducts,
    showPreferencesFunc,
    showPreferences,
    catalogLoaded,
    deliveryAlteredText,
    showCartUnsoldAlert,
    shouldRegister: initialShouldRegister,
    searchText,
    search,
    isCatalogEmpty,
    productsByCategory,
    filteredProductsByCategory,
    onFavouriteAddRemove,
    subscription,
    setSubscription,
    categories,
    isStaff,
    canCancelCart,
  } = props;
  const intl = useIntl();
  const windowWidth = useScreenWidth();
  const [activeTabIndex, setActiveTabIndex] = useState();
  const [fromFooter, setFromFooter] = useState();
  const stickyPaymentContainerRef = useRef(null);
  const cartRowRef = useRef(null);
  const cardHeaderRef = useRef(null);
  const [isPaymentSuccess, setIsPaymentSuccess] = useState(false);
  const isMobile = windowWidth < 940;

  const { isAuthenticated } = useContext(LoginContext);

  const onCartUpdate = () => console.log("unimplemented");
  const {
    editable,
    footer_text_in_shop,
    delivery_address: initialDeliveryAddress,
    pickup_address: initialPickupAddress,
    address,
    post_city,
    is_shipping,
    timeframe,
    get_next_editable_cart_url,
  } = delivery;
  const [delivery_address, setDeliveryAddress] = useState(
    initialDeliveryAddress,
  );
  const [pickup_address, setPickupAddress] = useState(initialPickupAddress);

  const [showPaymentPopup, setShowPaymentPopup] = useState(false);
  const [paymentPopupMessage, setPaymentPopupMessage] = useState("");

  const queryParams = new URLSearchParams(window.location.search);
  const action = queryParams.get("action");
  const shouldRedirect =
    action === "always-editable" && !editable && get_next_editable_cart_url;
  const [shouldRegister, setShouldRegister] = useState(initialShouldRegister);

  let isDeliveryAddress;

  if (delivery_address && !pickup_address) {
    isDeliveryAddress = true;
  }
  if (!delivery_address && pickup_address) {
    isDeliveryAddress = false;
  }
  const closeSettingsAndconfigureActiveTab = async (
    tabIndex,
    fromFooter = false,
  ) => {
    onSettingsClose();
    setFromFooter(fromFooter);
    setActiveTabIndex(tabIndex);
  };
  const openSettingsOrTab = (tabIndex, fromFooter = false) => {
    closeSettingsAndconfigureActiveTab(tabIndex, fromFooter).then(() => {
      onTopClick();
    });
  };

  const handleStripePaymentRedirect = () => {
    const url = new URL(window.location);
    const queryParams = url.searchParams;
    const redirectStatus = queryParams.get("redirect_status");
    const setupIntent = queryParams.get("setup_intent");
    const setupIntentClientSecret = queryParams.get(
      "setup_intent_client_secret",
    );
    const isFromRegistrationForm =
      queryParams.get("from_registration_form") || false;
    const cleanupUrl = () => {
      queryParams.delete("redirect_status");
      queryParams.delete("setup_intent");
      queryParams.delete("setup_intent_client_secret");
      queryParams.delete("from_registration_form");

      const newUrl = `${url.pathname}${
        queryParams.toString() ? "?" + queryParams.toString() : ""
      }`;
      window.history.pushState({}, "", newUrl);
    };

    if (
      redirectStatus === "succeeded" &&
      setupIntent &&
      setupIntentClientSecret
    ) {
      setShowRegistrationForm(false);
      setShowPaymentPopup(true);

      if (isFromRegistrationForm) {
        setPaymentPopupMessage(
          intl.formatMessage({ id: "havePatienceWhileProcessing" }),
        );
      } else {
        setPaymentPopupMessage(intl.formatMessage({ id: "havePatience" }));
      }

      put(subscription.customer.payment_url, {
        body: { setup_intent_id: setupIntent, payment_provider: "stripe" },
      })
        .then((customer) => {
          setIsPaymentSuccess(true);
          cleanupUrl();
          if (isFromRegistrationForm) {
            setShowPaymentPopup(false);
            onRegisterSuccess(customer, true);
          } else {
            setPaymentPopupMessage(
              intl.formatMessage({ id: "successfulPaymentMethod" }),
            );
          }
        })
        .catch(() => {
          cleanupUrl();
          setPaymentPopupMessage(
            intl.formatMessage({ id: "errorPaymentMethod" }),
          );
        });
    } else if (redirectStatus === "failed") {
      setShowPaymentPopup(true);
      cleanupUrl();
      setPaymentPopupMessage(intl.formatMessage({ id: "failedPaymentMethod" }));
    }
  };

  useEffect(() => {
    if (shouldRedirect) {
      window.location.href = get_next_editable_cart_url;
    }
  }, []);

  useEffect(() => {
    search(searchText);
    styles.colorPrimary = colorPrimary;
    styles.colorSecondary = colorSecondary;
    styles.logoSmallUrl = logoSmallUrl;
    if (subscription) setSubscription(subscription);

    // Add header and footer height calculations
    const headerHeight =
      document.querySelector(".cartHeader__container")?.clientHeight || 0;
    const footerHeight =
      document.querySelector(".footer-slim")?.clientHeight || 0;
    const searchBarHeight =
      document.querySelector(".search-container")?.clientHeight || 0;

    document.documentElement.style.setProperty(
      "--header-height",
      `${headerHeight}px`,
    );
    document.documentElement.style.setProperty(
      "--footer-height",
      `${footerHeight}px`,
    );
    document.documentElement.style.setProperty(
      "--search-bar-height",
      `${searchBarHeight}px`,
    );
  }, [props.reRender]);

  useEffect(() => {
    handleStripePaymentRedirect();
  }, []);

  const handleDownArrowClick = () => {
    const categoryElement = document.querySelector(".categorNavItem__title");
    if (categoryElement) {
      categoryElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  if (shouldRedirect) {
    return <></>;
  }

  return (
    <div className="cart">
      {showPaymentPopup && (
        <Alert
          colorSecondary={styles.colorSecondary}
          logoSmallUrl={styles.logoSmallUrl}
        >
          {paymentPopupMessage}
        </Alert>
      )}
      <GlobalContext.Provider
        value={{
          activeSearch,
          setActiveSearch,
          reRender: props.reRender,
          setRender: props.setRender,
          gmbhName,
          logoBigUrl,
          logoFavIcon,
          logoSmallUrl,
          phoneNumber,
          companyEmail,
          companyAddress,
          colorPrimary,
          colorSecondary,
          homePage,
          bioCertification,
          taxDetails,
          privacyPage,
          conditionsPage,
          webhost,
          companyName,
          deliveryName,
          productType,
          filteredProductType,
          userLikedProducts,
          hasRules,
          ruleCount,
          setRuleCount,
          preferencesAndRulesLoaded,
          isLoadingPreferencesAndRules,
          fetchPreferencesAndRules,
          fetchCatalog,
          setDelivery,
          fetchDelivery,
          onFavouriteAddRemove,
          setProductType,
          setFilteredProductType,
          setUserLikedProducts,
          catalogLoaded,
          windowWidth,
          subscription,
          setSubscription,
          delivery_address,
          setDeliveryAddress,
          pickup_address,
          setPickupAddress,
          creditorIdentifier,
          sepaCsvEmail,
          shouldRegister,
          setShouldRegister,
          isMobile,
        }}
      >
        {showRegistrationForm && !isPaymentSuccess && (
          <Welcome
            isDeliveryAddress={isDeliveryAddress}
            address={address}
            post_city={post_city}
            is_shipping={is_shipping}
            timeframe={timeframe}
            customer={subscription.customer}
            onSuccess={onRegisterSuccess}
            gmbhName={gmbhName}
            colorSecondary={colorSecondary}
            colorPrimary={colorPrimary}
            logoSmallUrl={logoSmallUrl}
            conditionsPage={conditionsPage}
            addInvoicePaymentMethod={addInvoicePaymentMethod}
            addSepaPaymentMethod={addSepaPaymentMethod}
            paymentProvider={paymentProvider}
            deliveryAlteredText={deliveryAlteredText}
            setShowRegistrationForm={setShowRegistrationForm}
          />
        )}
        {showCartUnsoldAlert &&
          (delivery.sold_and_edited || props.was_updated) && (
            <CartUnsoldItemsAlert
              colorSecondary={colorSecondary}
              logoSmallUrl={logoSmallUrl}
              soldAndEdited={delivery.sold_and_edited}
              updatedOrders={props.updated_orders}
              wasUpdated={props.was_updated}
              onPropagateOrderedAmount={props.onPropagateOrderedAmount}
            />
          )}
        {browser_is_IE && <BrowserWarning />}
        {showSettings && (
          <Settings
            subscription={subscription}
            delivery={delivery}
            onClose={onSettingsClose}
            onChange={onSettingsChange}
            isDeliveryAddress={isDeliveryAddress}
            delivery_address={delivery_address}
            is_shipping={is_shipping}
            pickup_address={pickup_address}
            timeframe={timeframe}
            logoSmallUrl={logoSmallUrl}
            conditionsPage={conditionsPage}
            phoneNumber={phoneNumber}
            companyEmail={companyEmail}
            webhost={webhost}
            addInvoicePaymentMethod={addInvoicePaymentMethod}
            addSepaPaymentMethod={addSepaPaymentMethod}
            paymentProvider={paymentProvider}
            catalogLoaded={catalogLoaded}
            activeTabIndex={activeTabIndex}
            setActiveTabIndex={setActiveTabIndex}
            fromFooter={fromFooter}
            setFromFooter={setFromFooter}
            companyAddress={companyAddress}
            bioCertification={bioCertification}
            taxDetails={taxDetails}
            privacyPage={privacyPage}
            homePage={homePage}
            visitedFromCart={false}
            isStaff={isStaff}
          />
        )}
        {showPreferences && (
          <>
            <Settings
              subscription={subscription}
              onClose={onSettingsClose}
              onChange={onSettingsChange}
              isDeliveryAddress={isDeliveryAddress}
              delivery_address={delivery_address}
              is_shipping={is_shipping}
              pickup_address={pickup_address}
              timeframe={timeframe}
              logoSmallUrl={logoSmallUrl}
              conditionsPage={conditionsPage}
              phoneNumber={phoneNumber}
              companyEmail={companyEmail}
              webhost={webhost}
              activeTabIndex={0}
              catalogLoaded={catalogLoaded}
              setActiveTabIndex={setActiveTabIndex}
              fromFooter={fromFooter}
              setFromFooter={setFromFooter}
              companyAddress={companyAddress}
              bioCertification={bioCertification}
              taxDetails={taxDetails}
              privacyPage={privacyPage}
              homePage={homePage}
              shouldRegister={shouldRegister}
              visitedFromCart={true}
              isStaff={isStaff}
            />
          </>
        )}
        <CartTop
          delivery={delivery}
          homePage={homePage}
          openSettingsOrTab={openSettingsOrTab}
          companyName={companyName}
          logoSmallUrl={logoSmallUrl}
          subscription={subscription}
        />
        <div className="cart__row-responsive" ref={cartRowRef}>
          <div className="cart__row cart__row-top">
            <div ref={cardHeaderRef}>
              <div className="setting-banner-wrapper">
                <div className="cart__down-arrow-wrapper">
                  <DownArrow
                    className="cart__down-arrow"
                    onClick={handleDownArrowClick}
                  />
                </div>
                <div className="settings-tabs__head">
                  {intl.formatMessage({ id: "cart" })}
                </div>
                <div style={{ position: 'relative' }}>
                  <ShoppingCart className="cart__basket-shopping-cart" />
                  {delivery?.orders?.length > 0 && (
                    <span className="cart-counter">{delivery.orders.length}</span>
                  )}
                </div>
              </div>
              <CartHeader
                delivery={delivery}
                address={address}
                subscription={subscription}
                onCartUpdate={onCartUpdate}
                showPreferencesFunc={showPreferencesFunc}
                colorPrimary={colorPrimary}
                cardHeaderRef={cardHeaderRef}
                openSettingsOrTab={openSettingsOrTab}
                isAuthenticated={isAuthenticated}
              />
            </div>
            <CartItemList
              delivery={delivery}
              onChange={onChangeItems}
              onRemove={onRemoveItems}
              editable={delivery.editable}
              delivery_smartfill_state={delivery.delivery_smartfill_state}
              delivery_suggestion_state={delivery.delivery_suggestion_state}
              days_until_ordering_window_opens={
                delivery.days_until_ordering_window_opens
              }
              allow_ordering_before_suggestions_at={
                delivery.allow_ordering_before_suggestions_at
              }
              nextEditableCart={get_next_editable_cart_url}
              remaining_time={delivery.remaining_time}
              companyEmail={companyEmail}
              stickyPaymentContainerHeight={
                stickyPaymentContainerRef
                  ? stickyPaymentContainerRef?.current?.clientHeight
                  : 0
              }
              cartRowHeight={cartRowRef ? cartRowRef?.current?.clientHeight : 0}
              cardHeaderHeight={
                cardHeaderRef ? cardHeaderRef?.current?.clientHeight : 0
              }
            />
            <div className="sticky-container" ref={stickyPaymentContainerRef}>
              <CartSummary
                delivery={delivery}
                companyEmail={companyEmail}
                onPropagateOrderedAmount={onPropagateOrderedAmount}
                toggleForceEditable={toggleForceEditable}
                onSwitchToEarlierDateIfExists={onSwitchToEarlierDateIfExists}
                nextEditableCart={get_next_editable_cart_url}
                wasUpdated={props.was_updated}
                colorSecondary={styles.colorSecondary}
                logoSmallUrl={styles.logoSmallUrl}
                isStaff={isStaff}
                canCancelCart={canCancelCart}
                fetchDelivery={fetchDelivery}
                isAuthenticated={isAuthenticated}
              />
              <CartOrderBar
                onSubmit={onSubmit}
                delivery={delivery}
                hasBeenClicked={hasBeenClicked}
                colorSecondary={colorSecondary}
                isStaff={isStaff}
              />
            </div>
          </div>
          {/* here is the point where the responsive should start */}
          <div className="cart__row cart__catalog">
            <LoadingSpinner
              isLoading={!catalogLoaded}
              clazzName={
                !catalogLoaded
                  ? "cart-wrapper__spinner"
                  : "cart-wrapper__container"
              }
              applyStylesToMain={true}
            >
              <CatalogItemList
                search={search}
                searchText={searchText}
                isGrid={subscription.customer.use_tile_design}
                delivery={delivery}
                allow_ordering_before_suggestions_at={
                  delivery.allow_ordering_before_suggestions_at
                }
                onChange={onChangeItems}
                isCatalogEmpty={isCatalogEmpty}
                isFilteredProduct={searchText !== ""}
                productsByCategory={
                  searchText !== ""
                    ? filteredProductsByCategory
                    : productsByCategory
                }
                onFavouriteAddRemove={onFavouriteAddRemove}
                footer_text_in_shop={footer_text_in_shop}
                categories={categories}
                reRender={() => {
                  props.setRender(!props.reRender);
                }}
              />
            </LoadingSpinner>
          </div>
        </div>
        <Footer
          currentLang={intl.locale}
          onFooterLinkClick={openSettingsOrTab}
        ></Footer>
      </GlobalContext.Provider>
    </div>
  );
}

function CartUnsoldItemsAlert(props) {
  const { soldAndEdited, updatedOrders, wasUpdated, onPropagateOrderedAmount } =
    props;
  const [isAlertVisible, setIsAlertVisible] = useState(true);

  const handleCloseAlertAndPropagate = (e) => {
    e.preventDefault();
    setIsAlertVisible(false);
    onPropagateOrderedAmount();
  };

  const message1 = soldAndEdited ? (
    <div>
      <p>
        <FormattedMessage id="unorderedChanges" />
      </p>
      <a href="#" onClick={handleCloseAlertAndPropagate}>
        <FormattedMessage id="undoChanges" />
      </a>
    </div>
  ) : (
    ""
  );
  const message2 = soldAndEdited ? (
    <p>
      <FormattedMessage id="saveUnorderedChanges" />{" "}
    </p>
  ) : (
    ""
  );
  const message3 = wasUpdated ? (
    <p>
      <FormattedMessage id="adjustedProducts" />
    </p>
  ) : (
    ""
  );
  const message4 = wasUpdated ? <p>{updatedOrders.join(", ")}</p> : "";

  return isAlertVisible ? (
    <>
      <Alert
        colorSecondary={styles.colorSecondary}
        logoSmallUrl={styles.logoSmallUrl}
      >
        {message1}
        {message2}
        {message3}
        {message4}
      </Alert>
    </>
  ) : null;
}

function BrowserWarning(props) {
  return (
    <>
      <NoAccess
        colorSecondary={styles.colorSecondary}
        logoSmallUrl={styles.logoSmallUrl}
      >
        <FormattedMessage id="useDifferentBrowser" />
      </NoAccess>
    </>
  );
}
